import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import FullButton from "../Buttons/FullButton";
import ServiceCard from "../Elements/ServiceCard";
import StatsBlock from "./StatsBlock";

export default function ServicesV2() {
  const [isInView, setIsInView] = useState(true); // Track if container is in view

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting); // Update state based on visibility
      },
      { threshold: 0.05 } // Trigger when 50% of the container is visible
    );
    const container = document.querySelector(".servicesContainer");
    observer.observe(container); // Observe the rotatedContainer

    return () => {
      observer.disconnect(); // Cleanup observer on unmount
    };
  }, []);
  return (
    <Wrapper>
      {/* <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div> */}
      <div className="whiteBg" style={{ padding: "20px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Pourquoi Nous Choisir</h1>
            {/* <p className="font13">
              Explorez nos formations de qualité conçues pour améliorer votre
              efficacité, renforcer votre fiabilité et développer votre
              adaptabilité dans un monde en constante évolution.
              <br />
              Val Academy vous accompagne dans l'acquisition de compétences
              essentielles pour exceller dans votre parcours professionnel.
            </p> */}
          </HeaderInfo>
          <ServiceBoxRow className="servicesContainer flex">
            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-laptop"
                title="Subvention"
                subtitle="Nos formations sont 100% subventionnées par l'OPCO"
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Comptability.json")
                }
                style={{ fontSize: 20 }}
                frontColor="linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))"
                backColor="linear-gradient(135deg,rgb(43, 61, 226),rgb(112, 218, 213))"
              />
            </ServiceBoxWrapper>
            <span style={{ margin: "10px" }}></span>
            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-language"
                title="Efficacité"
                subtitle="Nos formateurs sont des professionnels reconnus dans leurs domaines"
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Langue.json")
                }
                frontColor="linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))"
                backColor="linear-gradient(135deg,rgb(43, 226, 211),rgb(112, 218, 117))"
              />
            </ServiceBoxWrapper>
            <span style={{ margin: "10px" }}></span>
            <ServiceBoxWrapper style={{ marginRight: "20px" }}>
              <ServiceCard
                icon="fa-solid fa-user"
                title="Adaptabilité"
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/design.json")
                }
                subtitle="Nos formations sont flexibles et sont dispensées en présentiel ou en distanciel selon vos préférences"
                frontColor="linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))"
                backColor="linear-gradient(135deg,rgb(49, 226, 43),rgb(169, 218, 112))"
              />
            </ServiceBoxWrapper>
            <span style={{ margin: "30px" }}></span>
            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-users-cog"
                title="Qualité Garantie"
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Professionals.json")
                }
                subtitle="Nous avons aidé plus de 500 entreprises à se former et à se développer"
                frontColor="linear-gradient(135deg,rgb(255, 203, 106),rgb(255, 123, 0))"
                backColor="linear-gradient(135deg, rgb(167, 63, 181), rgb(243, 33, 198))"
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>

          {/* <ServiceBoxRow className="flex" style={{ marginTop: "-10%" }}>
            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-paintbrush"
                title="Infographie"
                subtitle="Libérez votre créativité grâce à des formations complètes sur Photoshop, Illustrator et InDesign."
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/InfoGraphie.json")
                }
                frontColor="linear-gradient(135deg, rgb(33, 150, 243), rgb(63, 81, 181))"
                backColor="linear-gradient(135deg, rgb(0, 188, 212), rgb(76, 175, 80))"
              />
            </ServiceBoxWrapper>
            <span style={{ margin: "10px" }}></span>

            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-calculator"
                title="Comptabilité / Paie"
                subtitle="Acquérez des connaissances pratiques en comptabilité et gestion de la paie avec des étapes détaillées et structurées."
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Comptability.json")
                }
                frontColor="linear-gradient(135deg, rgb(0, 212, 88), rgb(33, 150, 243))"
                backColor="linear-gradient(135deg, rgb(34, 255, 45), rgb(0, 255, 255))"
              />
            </ServiceBoxWrapper>
            <span style={{ margin: "10px" }}></span>

            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-briefcase"
                title="Professionnelle"
                subtitle="Explorez de nouveaux horizons professionnels et obtenez les compétences nécessaires pour réussir votre transition de carrière."
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Professionals.json")
                }
                frontColor="linear-gradient(135deg, rgb(233, 30, 99), rgb(156, 39, 176))"
                backColor="linear-gradient(135deg, rgb(167, 63, 181), rgb(243, 33, 198))"
              />
            </ServiceBoxWrapper>

            <span style={{ margin: "10px" }}></span>

            <ServiceBoxWrapper>
              <ServiceCard
                icon="fa-solid fa-bullhorn"
                title="Marketing Digital"
                subtitle="Développez des compétences en marketing numérique, apprenez à utiliser les outils modernes pour promouvoir votre entreprise en ligne."
                animationPath={
                  isInView === false
                    ? null
                    : require("../../assets/animation/Marketing.json")
                }
                frontColor="linear-gradient(135deg, rgb(168, 34, 195), rgb(253, 187, 45))"
                backColor="linear-gradient(135deg, rgb(219, 48, 81), rgb(255, 103, 31))"
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow> */}
        </div>
        {/* <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold">
                  Quelques mots sur l'entreprise
                </h4>
                <h2 className="font40 extraBold">Une étude de la créativité</h2>
                <p className="font12">
                  Nous mettons un point d'honneur à offrir des services
                  innovants qui stimulent la créativité et répondent aux besoins
                  uniques de chaque client.
                  <br />
                  <br /> Notre équipe combine expertise et passion pour créer
                  des solutions sur mesure.
                </p>
                <ButtonsRow
                  className="flexNullCenter"
                  style={{ margin: "30px 0" }}
                >
                  <div style={{ width: "190px" }}>
                    <FullButton
                      title="Inscription"
                      action={() => alert("Inscription")}
                    />
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                    <FullButton
                      title="Contactez-nous"
                      action={() => alert("Contactez-nous")}
                      border
                    />
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img
                        src={require("../../assets/img/Rotation/Person.jpg")}
                        height={406}
                        width={285}
                        alt="office"
                      />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img
                        src={require("../../assets/img/Rotation/Person2.jpg")}
                        height={333}
                        width={197}
                        alt="office"
                      />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img
                        src={require("../../assets/img/Rotation/Makeup (3).jpg")}
                        height={115}
                        width={112}
                        alt="office"
                      />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img
                        src={require("../../assets/img/Rotation/Font2.jpg")}
                        height={224}
                        width={197}
                        alt="office"
                      />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div> */}
        {/* <StatsBlock /> */}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
